var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72016 10.75C8.77786 10.75 7.83123 10.5309 6.88028 10.0928C5.92932 9.65462 5.0548 9.03651 4.25673 8.23844C3.46186 7.44036 2.84535 6.56665 2.40721 5.6173C1.96907 4.66794 1.75 3.72211 1.75 2.77981C1.75 2.62981 1.8 2.50401 1.9 2.40241C2 2.3008 2.125 2.25 2.275 2.25H3.90575C4.03203 2.25 4.14341 2.29119 4.23989 2.37356C4.33636 2.45594 4.39774 2.5577 4.42401 2.67885L4.71055 4.14999C4.73043 4.28653 4.72626 4.40384 4.69805 4.50191C4.66985 4.59999 4.61921 4.68236 4.54613 4.74903L3.39133 5.87306C3.57723 6.21345 3.78957 6.5354 4.02835 6.83893C4.26713 7.14246 4.52563 7.43237 4.80383 7.70865C5.07819 7.98301 5.36986 8.23782 5.67884 8.47308C5.98781 8.70833 6.32147 8.92724 6.6798 9.1298L7.80191 7.99808C7.88012 7.91667 7.97483 7.85962 8.08605 7.82693C8.19727 7.79423 8.31281 7.78622 8.43269 7.80289L9.82113 8.08558C9.94741 8.11891 10.0505 8.18333 10.1303 8.27884C10.2101 8.37436 10.25 8.48269 10.25 8.60385V10.225C10.25 10.375 10.1992 10.5 10.0976 10.6C9.99596 10.7 9.87016 10.75 9.72016 10.75Z",
    fill: "#111110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f99f06ba14771755bd158b5f2b374513.svg";
export { ForwardRef as ReactComponent };